import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ICreateChallengeTranslationRequest } from './create-challenge-translation-request';
import type { ICreateChallengeTranslationResponse } from './create-challenge-translation-response';
import { createChallengeTranslationResponseSchema } from './create-challenge-translation-response';

export async function createChallengeTranslationApi({
  challengeId,
  body,
}: ICreateChallengeTranslationRequest): Promise<
  IValidatedResponse<ICreateChallengeTranslationResponse>
> {
  return postRequest<ICreateChallengeTranslationResponse>({
    path: `/sys/challenges/${challengeId}/translations`,
    body,
    schema: createChallengeTranslationResponseSchema,
  });
}
